import { FileDetails } from './InfoBoxes/FileDetails';
import { ValidationInformation } from './InfoBoxes/ValidationInformation';
import { NftDetails } from './InfoBoxes/NftDetails';
// import { BlockInfo } from './InfoBoxes/BlockInfo';
// import { FileSegmentInfo } from './InfoBoxes/FileSegmentInfo';
import BlockchainDetailsTS from './InfoBoxes/BlockchainDetailsTS';

export const InfoBoxes = ({ reportData, files, handleNotValidated, blockHistory }) => {
  return (
    <div className="flex flex-col gap-2 sm:gap-4 ">
      <div className="flex flex-col lg:flex-row gap-4 sm:gap-6">
        <ValidationInformation
          reportData={reportData}
          files={files}
          handleNotValidated={handleNotValidated}
        />
        <FileDetails reportData={reportData} />
      </div>
      <div className="flex flex-col gap-2 sm:gap-4">
        {reportData.TOKEN_ID && <NftDetails reportData={reportData} />}
        {reportData.VALID === 1 && (
          <>
            <BlockchainDetailsTS reportData={reportData} blockHistory={blockHistory} />
            {/* TODO_ fix block info and segment info if needed */}
            {/* <BlockInfo reportData={reportData} /> */}
            {/* <FileSegmentInfo reportData={reportData} blockchainHistory={blockchainHistory} /> */}
          </>
        )}
      </div>
    </div>
  );
};

// OLD
// export const InfoBoxes = ({ reportData, blockchainHistory, files, handleNotValidated }) => {
//   return (
//     <div className="flex flex-row gap-[24px]">
//       <div className="flex flex-col gap-[24px]">
//         <ValidationInformation
//           reportData={reportData}
//           files={files}
//           handleNotValidated={handleNotValidated}
//         />
//         {reportData.VALID === 1 && reportData.VALIDATION_COMPLETE === 1 && (
//           <>
//             <BlockInfo blockchainHistory={blockchainHistory} />
//             <FileSegmentInfo reportData={reportData} blockchainHistory={blockchainHistory} />
//           </>
//         )}
//       </div>
//       <div className="flex flex-col gap-[24px]">
//         <FileDetails reportData={reportData} />
//         {reportData.TOKEN_ID && <NftDetails reportData={reportData} />}
//       </div>
//     </div>
//   );
// };
